import * as React from 'react';

interface ExperiencePointsSvgProps {
  text: number | string;
  short?: boolean;
}

const ExperiencePointsSvg: React.FC<ExperiencePointsSvgProps> = ({ text, short = false }) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 775.6 500"
      // style={{
      //   enableBackground: 'new 0 0 775.6 500',
      // }}
      xmlSpace="preserve"
    >
      <style>
        {
          '.st0{fill:#b5820f}.st1{fill:#16375b}.st2{fill:#4ba4b5}.st3{fill:#2a6bb2}.st4{fill:none;stroke:#b5820f;stroke-width:1.034}.st8{fill:#fff}'
        }
      </style>
      <path
        className="st0"
        d="M207.3 416.9c-5.4-5.4-4.7-26.6.3-33.1v-.1c-6.6 5.1-28 5.5-33.4.1l.6.6-.3-.3-.2-.2c5.4 5.4 5 26.9 0 33.4h.1c6.3-5.1 27.4-5.8 32.9-.4"
      />
      <path
        className="st1"
        d="M316.5 399.8c-4.5 0-13-9.1-13.6-13.9-.6 4.8-9.4 13.9-13.9 13.9h.5-.5c4.5 0 13.3 9.1 13.9 13.9.6-4.8 9.1-13.9 13.6-13.9M538.3 379.2c-8.2 0-23.7-16.6-24.9-25.4h-.1c-1.1 8.8-17.1 25.4-25.3 25.4h.8-.8c8.2 0 24.2 16.6 25.3 25.4h.1c1.2-8.8 16.7-25.3 24.9-25.4"
      />
      <path
        className="st2"
        d="M370.8 128.9c-8.9 0-25.6-17.9-26.9-27.4h-.1c-1.2 9.5-18.5 27.4-27.4 27.4h.9-.9c8.9 0 26.1 17.9 27.4 27.4h.1c1.3-9.5 18-27.4 26.9-27.4"
      />
      <path
        className="st0"
        d="M666.2 75c-3.8 0-10.9-7.6-11.4-11.7-.5 4.1-7.9 11.7-11.6 11.7h.4-.4c3.8 0 11.1 7.6 11.6 11.7.5-4.1 7.6-11.6 11.4-11.7M46.2 311.5c-7.5 0-21.8-15.2-22.8-23.3h-.1c-1.1 8.1-15.7 23.3-23.3 23.3h.8-.7c7.5 0 22.2 15.2 23.3 23.3h.1c.9-8.1 15.1-23.3 22.7-23.3M643.1 407.5c-7.5 0-21.8-15.2-22.8-23.3h-.1c-1.1 8.1-15.7 23.3-23.3 23.3h.8-.7c7.5 0 22.2 15.2 23.3 23.3h.1c1-8.1 15.2-23.2 22.7-23.3"
      />
      <path
        className="st3"
        d="M519.6 434.8c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.3 8.1-12.3 12.1-12.3"
      />
      <path
        className="st1"
        d="M70.6 341.5c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.3 8.1-12.3 12.1-12.3M775.6 189.4c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.2 8.1-12.3 12.1-12.3"
      />
      <path
        className="st0"
        d="M580 487.7c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.3 8.1-12.3 12.1-12.3"
      />
      <path
        className="st2"
        d="M293.4 441.7c-7.8 0-22.4-15.7-23.5-24h-.1c-1.1 8.3-16.2 24-23.9 24h.8-.7c7.8 0 22.9 15.7 23.9 24h.1c1-8.4 15.7-24 23.4-24"
      />
      <path
        className="st1"
        d="M412.4 62c-4 0-11.5-8.1-12.1-12.3C399.7 54 392 62 388 62h.4-.4c4 0 11.8 8.1 12.3 12.3.5-4.2 8.1-12.3 12.1-12.3"
      />
      <path
        className="st3"
        d="M500.3 108.6c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.5-4.2 8.1-12.2 12.1-12.3"
      />
      <path
        className="st1"
        d="M465.4 141.2c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.2 8.1-12.3 12.1-12.3"
      />
      <path
        className="st0"
        d="M313.4 12.3c-4 0-11.5-8.1-12.1-12.3-.6 4.3-8.3 12.3-12.3 12.3h.4-.4c4 0 11.8 8.1 12.3 12.3.6-4.2 8.1-12.2 12.1-12.3"
      />
      <path
        className="st1"
        d="M213.4 138.3c-7.5 0-21.8-15.2-22.8-23.3h-.1c-1.1 8.1-15.7 23.3-23.3 23.3h.8-.7c7.5 0 22.2 15.2 23.3 23.3h.1c1-8.1 15.2-23.2 22.7-23.3"
      />
      <path
        className="st0"
        d="M125.2 164.7c-3.4 0-9.8-6.8-10.2-10.5-.5 3.6-7 10.5-10.4 10.5h.3H104.6c3.4 0 10 6.8 10.4 10.5.5-3.7 6.8-10.5 10.2-10.5"
      />
      <path
        className="st1"
        d="M643.1 43.3c-6 0-17.4-12.2-18.3-18.7h-.1c-.8 6.5-12.6 18.7-18.6 18.7h.6-.6c6 0 17.8 12.2 18.6 18.7h.1c.9-6.5 12.3-18.6 18.3-18.7"
      />
      <path
        className="st2"
        d="M729.3 157.7c-6 0-17.4-12.2-18.3-18.7h-.1c-.8 6.5-12.6 18.7-18.6 18.7h.6-.6c6 0 17.8 12.2 18.6 18.7h.1c.9-6.5 12.2-18.7 18.3-18.7"
      />
      <path
        className="st0"
        d="M267.9 82c-12.7.4-37.6-27.2-39.9-42.3h-.1c-1.2 15.2-24.9 44.6-37.5 45l1.3-.1h-1.2c12.7-.4 38.3 27.2 40.6 42.3h.1c1.1-15.2 24-44.4 36.7-44.9M481 433.4c-13.2.5-39.4-33.2-41.8-51.5h-.1c-1.2 18.5-25.7 53.9-38.9 54.3l1.4-.1H400.3c13.2-.5 40.1 33.1 42.6 51.5h.1c1.1-18.4 24.8-53.7 38-54.2M615.6 91.7C602 91.7 576.3 58 574.4 40h-.1c-1.9 18-28.4 51.7-42 51.7h1.4-1.4c13.6 0 40.1 33.7 42 51.7h.1c1.9-17.9 27.5-51.6 41.2-51.7"
      />
      <path
        className="st4"
        d="M248.2 104.1s28.5 10.1 45.9 70M369.8 358.1s5.3 44.3 48.8 57.1M553.9 117.1s-35.8 37-33.2 58.4M214.6 402.5s41.3-18.8 47.4-54.8"
      />
      <path
        className="st3"
        d="M91.1 141.2c-6.7 0-19.4-13.5-20.3-20.7h-.1c-.9 7.2-14 20.7-20.7 20.7h.7-.7c6.7 0 19.7 13.5 20.7 20.7h.1c1-7.2 13.6-20.7 20.3-20.7M771.6 326.6c-6.7 0-19.4-13.5-20.3-20.7h-.1c-.9 7.2-14 20.7-20.7 20.7h.7-.7c6.7 0 19.7 13.5 20.7 20.7h.1c1-7.2 13.6-20.7 20.3-20.7"
      />
      <path
        style={{
          fill: 'none',
        }}
        d="M0 0h775.6v500H0z"
      />
      <path
        style={{
          fill: '#178837',
        }}
        d="m165.3 182.1-76.4 76.3 76.4 76.4h508l76.4-76.4-76.4-76.3z"
      />
      <path
        transform="rotate(-45.001 165.3 258.44)"
        style={{
          fill: '#147232',
        }}
        d="M111.3 204.4h108v108h-108z"
      />
      <path className="st8" d="m202 242.7-8.8-8.8-39.2 39.2-19.4-19.4-8.7 8.8 28.1 28.1.4-.4z" />
      <text
        transform={short ? 'translate(260 285)' : 'translate(310.255 287)'}
        className="st8"
        style={{
          fontSize: short ? '65' : '74',
          fontFamily: "'SegoeUI'",
        }}
      >
        {text}
      </text>
    </svg>
  );
};

export default ExperiencePointsSvg;
